import { controllerFactory } from "@utils/createController";
import * as Confetti from "canvas-confetti";

const inlineStylesFormObject = (
  styles: { [key: string]: number | string } = {},
) => {
  const resultAsArray = Object.keys(styles).map((property) => {
    const value = styles[property];

    return `${property}:${value}`;
  });

  return resultAsArray.join(";");
};

export default class extends controllerFactory()({
  targets: {
    source: HTMLElement,
  },
}) {
  canvasElement = null as HTMLCanvasElement | null;

  connect() {
    if (this.canvasElement) {
      return this.canvasElement;
    }

    // Create a canvas as big as the screen and make it fixed and on top of everything
    const myCanvas = document.createElement("canvas");
    myCanvas.style.cssText = inlineStylesFormObject({
      bottom: 0,
      height: "100%",
      left: 0,
      "pointer-events": "none",
      position: "fixed",
      right: 0,
      top: 0,
      width: "100%",
      "z-index": "9999",
    });

    // Add it to the DOM
    document.body.appendChild(myCanvas);

    // Cache it
    this.canvasElement = myCanvas;
  }

  spray() {
    const clientRect = this.sourceTarget.getBoundingClientRect();
    const clientX = (clientRect.left + clientRect.right) / 2;
    const clientY = (clientRect.top + clientRect.bottom) / 2;

    this.instance({
      origin: {
        x: clientX / window.innerWidth,
        y: clientY / window.innerHeight,
      },
      particleCount: 100,
      spread: 70,
    });
  }

  get instance() {
    return Confetti.create(this.canvasElement as HTMLCanvasElement, {
      resize: true,
    });
  }
}
